import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Select, { SelectProps } from '../Select'

export default function SelectStatus({
  formikProps,
  mode = 'multiple',
  name,
  label,
  onChange,
  options: defaultOptions,
  ...props
}: SelectProps) {
  const { t } = useTranslation()

  const options = useMemo(() => {
    return defaultOptions.map(item => ({
      ...item,
      value: `${item.value}`,
      label: `${t(item.label)}`,
      title: `${t(item.label)}`
    }))
  }, [defaultOptions, t])

  return (
    <Select
      {...props}
      dataTestId="status-list"
      formikProps={formikProps}
      label={label}
      mode={mode}
      name={name}
      options={options}
      placeholder="web.select-status.placeholder"
    />
  )
}
